<script setup lang="ts"></script>

<template>
  <h2 class="sm:text-lg">
    <slot />
  </h2>
</template>

<style scoped></style>
